import type { ReactNode } from 'react';
export function EmptyState({ title, body, action }: { title: string; body: string; action?: ReactNode }) {
  return (
    <div className="empty-state panel">
      <div className="empty-emoji">✨</div>
      <h2>{title}</h2>
      <p>{body}</p>
      {action}
    </div>
  );
}
